const adviser = {
  '--primary': '#00594c',
  '--secondary': '#008264',
  '--tertiary': '#00b74f',
};
export default adviser;
